module.exports = __webpack_public_path__ + "img/hd_outgoing_goods_1.415a5a2b.png";